// When REACT_APP_E2E=true the app runs against in-memory repositories with
// authentication bypassed, so Playwright e2e tests can exercise the UI without
// a Cognito user or an AWS backend. Never set this for a real deployment.
export const isE2EMode = process.env.REACT_APP_E2E === "true";
